import React, { useEffect, useState } from "react";
import { Col, Row, Table, Button, Modal } from "antd";
import "./style.css";
import { BUTTONS } from "../common/constants";
import { getApis } from "../common/api";
import { subscriptionComboPlansUrl } from "../common/endpoints";
import columnsData from "./columns";
import SubscriptionModal from "./subscriptionModal";

const dummySubscriptionData = {
  id: 1,
  name: "Gold",
  description: "Gold Package",
  status: "ACTIVE",
  fields: [
    {
      id: 60,
      fieldName: "longitude",
      fieldType: "LOCATION",
    },
  ],
};

const Subscriptions = () => {
  const authToken = localStorage.getItem("authToken");
  const [viewSubscription, setViewSubscription] = useState(false);
  const [subscriptionList, setSubscriptionList] = useState([]);

  const subscriptionModalOpen = () => {
    setViewSubscription(true);
  };

  const subscriptionModalClose = () => {
    setViewSubscription(false);
  };

  const columns = columnsData(subscriptionModalOpen);

  const getSubscriptionPlans = async () => {
    await getApis(subscriptionComboPlansUrl, {}, authToken)
      .then((response) => {
        setSubscriptionList(response?.data);
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    getSubscriptionPlans();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Row justify="space-between" className="flex-center">
        <Col span={4} className="head">
          Subscriptions
        </Col>
        <Col span={3}>
          <Button type="primary" onClick={null} disabled>
            {BUTTONS.ADD_NEW}
          </Button>
        </Col>
      </Row>
      <Row justify="center" className="mt1">
        <Col span={24}>
          <Table
            columns={columns}
            rowKey={(record) => record.id}
            dataSource={subscriptionList}
            pagination={subscriptionList.length > 10 ? { pageSize: 10 } : false}
            scroll={{ x: "100%" }}
          />
        </Col>
      </Row>
      <Modal
        title={"Subscription"}
        centered
        open={viewSubscription}
        onCancel={subscriptionModalClose}
        footer={null}
      >
        <SubscriptionModal data={dummySubscriptionData} />
      </Modal>
    </>
  );
};

export default Subscriptions;
